import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function Modal({
  type,
  onClose
}: {
  type: ModalType;
  onClose: () => void;
}) {
  if (!type) return null;
  const content = {
    privacy: {
      title: 'Política de Privacidad',
      body: <div className="space-y-6 text-matrix-white/80 font-light" data-id="element-75">
          <p data-id="element-76">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <div data-id="element-77">
            <h3 className="text-matrix-cream font-cinzel text-lg mb-2" data-id="element-78">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-79">
              Recopilamos únicamente la información necesaria para procesar tu
              compra y entregarte el producto digital. Esto incluye tu nombre,
              dirección de correo electrónico y datos de pago procesados de
              forma segura a través de nuestro proveedor de pagos.
            </p>
          </div>

          <div data-id="element-80">
            <h3 className="text-matrix-cream font-cinzel text-lg mb-2" data-id="element-81">
              2. Uso de la Información
            </h3>
            <p data-id="element-82">
              Tu información personal se utiliza exclusivamente para: procesar y
              entregar tu compra, enviarte el acceso al producto digital, y
              comunicarnos contigo respecto a tu pedido. No vendemos, alquilamos
              ni compartimos tu información personal con terceros.
            </p>
          </div>

          <div data-id="element-83">
            <h3 className="text-matrix-cream font-cinzel text-lg mb-2" data-id="element-84">
              3. Protección de Datos
            </h3>
            <p data-id="element-85">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger tu información personal contra acceso no autorizado,
              alteración, divulgación o destrucción.
            </p>
          </div>

          <div data-id="element-86">
            <h3 className="text-matrix-cream font-cinzel text-lg mb-2" data-id="element-87">
              4. Cookies
            </h3>
            <p data-id="element-88">
              Nuestro sitio web puede utilizar cookies para mejorar tu
              experiencia de navegación y analizar el tráfico del sitio. Puedes
              configurar tu navegador para rechazar cookies, aunque esto podría
              afectar la funcionalidad del sitio.
            </p>
          </div>

          <div data-id="element-89">
            <h3 className="text-matrix-cream font-cinzel text-lg mb-2" data-id="element-90">
              5. Tus Derechos
            </h3>
            <p data-id="element-91">
              Tienes derecho a acceder, rectificar o eliminar tu información
              personal en cualquier momento. También puedes solicitar la
              portabilidad de tus datos o retirar tu consentimiento para el
              procesamiento de los mismos.
            </p>
          </div>

          <div data-id="element-92">
            <h3 className="text-matrix-cream font-cinzel text-lg mb-2" data-id="element-93">
              6. Cambios en esta Política
            </h3>
            <p data-id="element-94">
              Nos reservamos el derecho de actualizar esta política de
              privacidad en cualquier momento. Los cambios serán publicados en
              esta página con la fecha de actualización correspondiente.
            </p>
          </div>
        </div>
    },
    terms: {
      title: 'Términos y Condiciones',
      body: <div className="space-y-6 text-matrix-white/80 font-light" data-id="element-95">
          <p data-id="element-96">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          <div data-id="element-97">
            <h3 className="text-matrix-cream font-cinzel text-lg mb-2" data-id="element-98">
              1. Aceptación de los Términos
            </h3>
            <p data-id="element-99">
              Al acceder y utilizar este sitio web y adquirir nuestros productos
              digitales, aceptas estar sujeto a estos términos y condiciones. Si
              no estás de acuerdo con alguna parte de estos términos, no debes
              utilizar nuestro sitio.
            </p>
          </div>

          <div data-id="element-100">
            <h3 className="text-matrix-cream font-cinzel text-lg mb-2" data-id="element-101">
              2. Producto Digital
            </h3>
            <p data-id="element-102">
              El producto ofrecido es un libro digital (ebook) en formato
              electrónico. Al completar tu compra, recibirás acceso inmediato al
              contenido. El producto se entrega tal como se describe en la
              página de venta.
            </p>
          </div>

          <div data-id="element-103">
            <h3 className="text-matrix-cream font-cinzel text-lg mb-2" data-id="element-104">
              3. Licencia de Uso
            </h3>
            <p data-id="element-105">
              Al adquirir el producto, se te otorga una licencia personal, no
              transferible y no exclusiva para acceder y leer el contenido.
              Queda prohibida la reproducción, distribución, modificación o
              reventa del material sin autorización expresa.
            </p>
          </div>

          <div data-id="element-106">
            <h3 className="text-matrix-cream font-cinzel text-lg mb-2" data-id="element-107">
              4. Política de Reembolso
            </h3>
            <p data-id="element-108">
              Debido a la naturaleza digital del producto y su entrega
              inmediata, todas las ventas son finales. No se ofrecen reembolsos
              una vez que se ha accedido al contenido digital.
            </p>
          </div>

          <div data-id="element-109">
            <h3 className="text-matrix-cream font-cinzel text-lg mb-2" data-id="element-110">
              5. Propiedad Intelectual
            </h3>
            <p data-id="element-111">
              Todo el contenido del libro digital, incluyendo texto, gráficos y
              diseño, está protegido por derechos de autor. El uso no autorizado
              del material puede resultar en acciones legales.
            </p>
          </div>

          <div data-id="element-112">
            <h3 className="text-matrix-cream font-cinzel text-lg mb-2" data-id="element-113">
              6. Limitación de Responsabilidad
            </h3>
            <p data-id="element-114">
              El contenido del libro es de carácter informativo y educativo. No
              nos hacemos responsables por las decisiones o acciones que el
              lector tome basándose en el contenido del libro. Los resultados
              pueden variar según cada individuo.
            </p>
          </div>

          <div data-id="element-115">
            <h3 className="text-matrix-cream font-cinzel text-lg mb-2" data-id="element-116">
              7. Modificaciones
            </h3>
            <p data-id="element-117">
              Nos reservamos el derecho de modificar estos términos y
              condiciones en cualquier momento. Las modificaciones entrarán en
              vigor inmediatamente después de su publicación en el sitio web.
            </p>
          </div>
        </div>
    }
  };
  const {
    title,
    body
  } = content[type];
  return <AnimatePresence data-id="element-118">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-119">
        
        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="bg-matrix-dark border border-matrix-green/30 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-120">
          
          <div className="flex items-center justify-between p-6 border-b border-matrix-green/20" data-id="element-121">
            <h2 className="font-cinzel text-2xl text-matrix-cream" data-id="element-122">{title}</h2>
            <button onClick={onClose} className="text-matrix-white/50 hover:text-matrix-green transition-colors p-1" aria-label="Cerrar" data-id="element-123">
              
              <XIcon size={24} data-id="element-124" />
            </button>
          </div>
          <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-sm leading-relaxed" data-id="element-125">
            {body}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-matrix-black py-8 border-t border-matrix-green/10 px-4" data-id="element-126">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-4" data-id="element-127">
          <div className="flex items-center gap-6" data-id="element-128">
            <button onClick={() => setActiveModal('privacy')} className="text-matrix-white/40 hover:text-matrix-green text-sm transition-colors duration-200" data-id="element-129">
              
              Política de Privacidad
            </button>
            <span className="text-matrix-white/20" data-id="element-130">•</span>
            <button onClick={() => setActiveModal('terms')} className="text-matrix-white/40 hover:text-matrix-green text-sm transition-colors duration-200" data-id="element-131">
              
              Términos y Condiciones
            </button>
          </div>
          <p className="text-matrix-white/30 text-xs" data-id="element-132">
            © {new Date().getFullYear()} ¿Estás listo para jugar? Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {activeModal && <Modal type={activeModal} onClose={() => setActiveModal(null)} data-id="element-133" />}
    </>;
}